<!--
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 -->

<template>
  <ConfirmDialog/>
  <DynamicDialog/>
  <Toast ref="toast" />
  <div>
    <WasmUpdateBanner />
    <div id="nav" class="sticky top-0 z-50 w-full">
      <Navbar @localeChanged="setUILocale"></Navbar>
    </div>
    <div id="body" class="relative">
      <router-view v-slot="{ Component, route }">
        <transition name="fade">
          <keep-alive include="Administration,Scene,Data">
            <component
              :is="Component"
              :key="getKeyId(route.name)"
              @localeChanged="setUILocale"
            />
          </keep-alive>
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script lang="ts">
  import s from './scripts/App';
  export default s;
</script>
